const activeAppDomains = ['www.myeduquiz.com','myeduquiz.com','www.gr8vault.com','gr8vault.com','lgsxxlarge.com'
,'www.lgsxxlarge.com','www.myeduconcept.com','myeduconcept.com'
]
const defaultDomain =   'www.myeduquiz.com';

export default {
    domains: activeAppDomains,
    defaultDomain
};